import React, { useContext, useState } from "react";
import ActionButton from "../Button/ActionButton";
import HorizontalBarChart from "../d3Charts/HorizontalBarChart/HorizontalBarChart";
import { AppContext } from "../../context/AppContext";
import "./Repositories.scss";
import Loader from "../Loader/Loader";
import { colorArray } from "../../utils/theme";
import AboutChartToggle from "../AboutChartToggle/AboutChartToggle";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";

const RepositoriesInner = ({ chartData, isLoading }) => {
  const { get, set, setMultiple } = useCustomSearchParams();
  const [shortName, setShortName] = useState(get(SEARCH_PARAMS.SHORT_NAME));
  const { entityName } = useContext(AppContext);
  return (
    <div className="repo-wrapper">
      {/* <p className={`repositories-msg-container`}>
        Graph represents the top 10 dataset repositories associated with the
        datasets related to the publications reporting on funded research. Hover
        over colored bars to see the full name of the repository and values. Clicking on a repository's name will truncate the text.
      </p> */}
      <div className="mb-3">
        <AboutChartToggle
          notes="Graph represents the top 10 dataset repositories associated with the
        datasets related to the publications reporting on funded research. Hover
        over colored bars to see the full name of the repository and values."
        />
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <div className="repositories-chart">
          <HorizontalBarChart
            chartData={chartData?.data?.slice(0, 10)}
            chartConfig={chartData?.config}
            title={`${shortName} Repositories Tracked by CHORUS`}
            //     notes="Graph represents the top 10 dataset repositories associated with the
            // datasets related to the publications reporting on funded research. Hover
            // over colored bars to see the full name of the repository and values."
            selectedNumberOfItem={chartData?.data?.length}
            colorArray={colorArray}
          />
        </div>
      )}
    </div>
  );
};

const Repositories = (props) => (
  <ErrorBoundary>
    <RepositoriesInner {...props} />
  </ErrorBoundary>
);

export default Repositories;
